import { animate, query, style } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit {

  @Input() elevated = false;
  @Input() border = false;
  @Input() animateTitle = false;
  @Input() animateShadow = false;

  titleAnimation = query(':self', [
    style({ transform: 'translateY(56px)' }),
    animate('1000ms', style({ transform: 'translateY(0)' }))
  ]);
  shadowAnimation = query(':self', [
    style({ boxShadow: 'none' }),
    animate('1000ms', style({
      boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
      borderColor: 'transparent'
    }))
  ]);

  constructor() { }

  ngOnInit(): void {
  }

}
